import React from 'react';
import styled from 'styled-components/macro';
import { Field, useFormikContext } from 'formik';
import {
  FieldContainer,
  Row,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';
import { StatsCard } from '../StatsCard';
import { SMSSettingChangeConfirmationModal } from '../SMSSettingChangeConfirmationModal';
import { Button } from 'react-covideo-common';
import { SuperAdminCustomerDetails } from 'lib/context';
import { DEFAULT_10DLC_COUNTRY } from 'lib/const/SuperAdminConstants';

const FieldWrapper = styled.div`
  flex: 1;
`;

export const SmsSettingSection = () => {
  const { setFieldValue, values } =
    useFormikContext<SuperAdminCustomerDetails>();
  const [showDeactivationConfirmModal, setShowDeactivationConfirmModal] =
    React.useState<boolean>(false);

  return (
    <Section>
      <SectionTitle>SMS Settings</SectionTitle>
      <RowWrapper>
        <Row alignItem='normal' justifyContent='space-between'>
          {!!values.smsEnabled && (
            <>
              <StatsCard
                count={values.sentSmsCount ?? 0}
                text={'sent this month'}
              />
              <StatsCard
                count={values.remainingSmsCount ?? 0}
                text={'remaining'}
                marginLeft={8}
              />
            </>
          )}

          <FieldWrapper style={{ flex: 0 }}>
            <Field name='smsEnabled'>
              {() => {
                return (
                  <FieldContainer>
                    <Button
                      variant={values.smsEnabled ? 'red' : 'secondary'}
                      onClick={() => {
                        if (values.smsEnabled) {
                          setShowDeactivationConfirmModal(true);
                          return;
                        }
                        setFieldValue(`smsEnabled`, 1);
                        setFieldValue(`location`, '');
                        setFieldValue(`number`, '');
                        setFieldValue(`paidSmsPerMonth`, 0);
                        setFieldValue(`freeSmsPerMonth`, 0);
                        setFieldValue(`country`, DEFAULT_10DLC_COUNTRY);
                        setFieldValue('customer10Dlc', {
                          ...values.customer10Dlc,
                          legalCompanyName: values.business || '',
                          w9ContactEmail: values.email || '',
                          w9ContactPhone: values.phone1 || '',
                          websiteUrl: values.url || '',
                        });
                      }}
                      text={
                        values.smsEnabled ? 'Deactivate SMS' : 'Activate SMS'
                      }
                    />
                  </FieldContainer>
                );
              }}
            </Field>
          </FieldWrapper>
        </Row>
      </RowWrapper>
      {showDeactivationConfirmModal && (
        <SMSSettingChangeConfirmationModal
          handleModalClose={deactivate => {
            if (deactivate) {
              setFieldValue(`smsEnabled`, 0);
              setFieldValue(`location`, '');
              setFieldValue(`number`, '');
              setFieldValue(`paidSmsPerMonth`, 0);
              setFieldValue(`freeSmsPerMonth`, 0);
            }
            setShowDeactivationConfirmModal(false);
          }}
        />
      )}
    </Section>
  );
};
